import ItemProdDbService from '@/services/admin/itemProdDb.service'
import router from '@/router'

const state =  {
}

const getters = {
}

const actions = {
    //----------------Prod Db Item ------------
    async searchProdDbItems({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await ItemProdDbService.searchProdDbItems(payload);

            return response
        } catch (e) {
            console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })
        }
    },

    //----------------Mapping GP Item into Prod Db Item ------------
    async getNotMappedGpItems({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await ItemProdDbService.getNotMappedGpItems(payload);

            return response
        } catch (e) {
            console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })
        }
    },
    async mapGpItemToItmProdDbItem({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await ItemProdDbService.mapGpItemToItmProdDbItem(payload);

            return response
        } catch (e) {
            console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }
    },



    //----------------Prod Db Item ProdDbType------------
    async saveItemProdType({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await ItemProdDbService.saveItemProdType(payload);

            return response
        } catch (e) {
            console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })
        }
    },


    //----------------Prod Db Item Status------------
    async saveItemStatus({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await ItemProdDbService.saveItemStatus(payload);

            return response
        } catch (e) {
            console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })
        }
    },


    //----------------Prod Db Item X Doc------------
    async deleteItemXDoc({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await ItemProdDbService.deleteItemXDoc(payload);

            return response
        } catch (e) {
            console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })
        }
    },
    async saveItemXDoc({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await ItemProdDbService.saveItemXDoc(payload);

            return response
        } catch (e) {
            console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }
    },
    //----------------Prod Item Doc-------------
    async getItmDocs({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await ItemProdDbService.getItmDocs(payload);

            return response
        } catch (e) {
            console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })
        }
    },
    async saveItmDoc({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await ItemProdDbService.saveItmDoc(payload);

            return response
        } catch (e) {
            console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }
    },

}

const mutations = {
}

export const adminItemProdDb = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}